import request from '@/utils/request'

export const financialCategoryApi = {
  // 获取收支分类树
  getTree() {
    return request({
      url: '/inventory-management-api/common/category/tree',
      method: 'POST',
      data: {
        type: 'financial'
      }
    })
  },

  // 批量编辑收支分类
  batchUpdate(data) {
    return request({
      url: '/inventory-management-api/common/category/batchUpdate',
      method: 'POST',
      data
    })
  },

  // 删除分类
  delete(id) {
    return request({
      url: '/inventory-management-api/common/category/delete',
      method: 'POST',
      data: { id }
    })
  }
}